(function () {
  var KO_RE = /[\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7A3\uD7B0-\uD7FF]+/g;
  /* En dash / multiply / plus / tilde sit slightly low in Sabon */
  var OPTICAL_RE = /[\u2013\u00D7+~]/g;
  var SKIP = {
    SCRIPT: 1,
    STYLE: 1,
    TEXTAREA: 1,
    NOSCRIPT: 1,
    CODE: 1,
    PRE: 1,
    KBD: 1,
    SAMP: 1,
  };

  function appendKoWord(frag, word, parent) {
    if (!word) return;
    var span = document.createElement('span');
    span.className = 'font-ko';
    span.textContent = word;
    frag.appendChild(span);
    if (parent && !parent.classList.contains('has-font-ko')) {
      parent.classList.add('has-font-ko');
    }
  }

  function wrapTextNode(node) {
    var text = node.nodeValue;
    var parent = node.parentElement;
    KO_RE.lastIndex = 0;
    if (!text || !KO_RE.test(text)) return;
    KO_RE.lastIndex = 0;

    var frag = document.createDocumentFragment();
    var last = 0;
    var match;

    while ((match = KO_RE.exec(text))) {
      if (match.index > last) {
        frag.appendChild(document.createTextNode(text.slice(last, match.index)));
      }

      var words = match[0].split(/(\s+)/);
      words.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(part));
        } else {
          appendKoWord(frag, part, parent);
        }
      });

      last = match.index + match[0].length;
    }

    if (last < text.length) {
      frag.appendChild(document.createTextNode(text.slice(last)));
    }

    node.parentNode.replaceChild(frag, node);
  }

  function wrapOpticalNode(node) {
    var text = node.nodeValue;
    OPTICAL_RE.lastIndex = 0;
    if (!text || !OPTICAL_RE.test(text)) return;
    OPTICAL_RE.lastIndex = 0;

    var frag = document.createDocumentFragment();
    var last = 0;
    var match;

    while ((match = OPTICAL_RE.exec(text))) {
      if (match.index > last) {
        frag.appendChild(document.createTextNode(text.slice(last, match.index)));
      }
      var span = document.createElement('span');
      span.className =
        match[0] === '+' ? 'optical-raise optical-raise--plus' : 'optical-raise';
      span.textContent = match[0];
      frag.appendChild(span);
      last = match.index + match[0].length;
    }

    if (last < text.length) {
      frag.appendChild(document.createTextNode(text.slice(last)));
    }

    node.parentNode.replaceChild(frag, node);
  }

  function collectTextNodes(root) {
    if (!root) return [];

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (parent.closest('.font-ko, .optical-raise')) return NodeFilter.FILTER_REJECT;
        if (SKIP[parent.tagName] || parent.isContentEditable) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    return nodes;
  }

  function walk(root) {
    collectTextNodes(root).forEach(wrapTextNode);
    collectTextNodes(root).forEach(wrapOpticalNode);
  }

  function init() {
    walk(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();